// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hero{
    height: 100vh;
    background: linear-gradient(180deg, #fde1ff, #e1ffea22 60%);
    display: flex;
}
.hero-left{
    flex: 1 1;
    display: flex;
    flex-direction: column;
    justify-content: center;
    gap: 20px;
    padding-left: 180px;
    line-height: 1.1;
}
.hero-left h2{
    color: #090909;
    font-size: 26px;
    font-weight: 600;

}
.hero-left p{
    color: #171717;
    font-size: 100px;
    font-weight: 700;

}
.hero-hand-icon{
    display: flex;
    align-items: center;
    gap: 20px;

}
.hero-hand-icon img{
    width: 105px;

}
.hero-latest-btn{
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 15px;
    width: 310px;
    height: 70px;
    border-radius: 75px;
    margin-top: 30px;
    background: #ff4141;
    color: white;
    font-size: 22px;
    font-weight: 500;

}
.hero-right{
    flex: 1 1;
    display: flex;
    align-items: center;
    justify-content: center;

}

@media(max-width:1280px){
    .hero-left{
        padding-left: 100px; 
    }
    .hero-left h2{
        font-size: 22px;
    }
    .hero-left p{
        font-size: 60px;
    }
    .hero-hand-icon img{
        width: 80px;
    }
    .hero-latest-btn{
        gap: 10px;
        width: 250px;
        height: 60px;
        margin-top: 20px;
        font-size: 18px;
    }
    .hero-right img{
        width: 500px;
    }
}
@media(max-width:1024px){
    .hero-left{
        padding-left: 80px; 
    }
    .hero-left h2{
        font-size: 20px;
    }
    .hero-left p{
        font-size: 50px;
    }
    .hero-hand-icon img{
        width: 65px;
    }
    .hero-latest-btn{
        width: 220px;
        height: 50px;
        font-size: 16px;
    }
    .hero-right img{
        width: 400px;
    }
}
@media(max-width:800px){
    .hero-left{
        padding-left: 30px; 
    }
    .hero-left h2{
        font-size: 16px;
    }
    .hero-left p{
        font-size: 40px;
    }
    .hero-hand-icon img{
        width: 50px;
    }
    .hero-latest-btn{
        width: 175px;
        height: 40px;
        font-size: 13px;
    }
    .hero-right img{
        width: 300px;
    }
}
@media(max-width:500px){
    .hero{
        flex-direction: column;
    }
    .hero-right{
        display: none;
    }
    
    .hero-left h2{
        font-size: 18px;
    }
    .hero-left p{
        font-size: 50px;
    }
    .hero-hand-icon img{
        width: 55px;
    }
    .hero-latest-btn{
        width: 200px;
        height: 45px;
        font-size: 14px;
    }
    .hero-right img{
        width: 300px;
    }
}`, "",{"version":3,"sources":["webpack://./src/Components/Hero/Hero.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,2DAA2D;IAC3D,aAAa;AACjB;AACA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,SAAS;IACT,mBAAmB;IACnB,gBAAgB;AACpB;AACA;IACI,cAAc;IACd,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,cAAc;IACd,gBAAgB;IAChB,gBAAgB;;AAEpB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,SAAS;;AAEb;AACA;IACI,YAAY;;AAEhB;AACA;IACI,aAAa;IACb,uBAAuB;IACvB,mBAAmB;IACnB,SAAS;IACT,YAAY;IACZ,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,mBAAmB;IACnB,YAAY;IACZ,eAAe;IACf,gBAAgB;;AAEpB;AACA;IACI,SAAO;IACP,aAAa;IACb,mBAAmB;IACnB,uBAAuB;;AAE3B;;AAEA;IACI;QACI,mBAAmB;IACvB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,SAAS;QACT,YAAY;QACZ,YAAY;QACZ,gBAAgB;QAChB,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,kBAAkB;IACtB;IACA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ;AACA;IACI;QACI,sBAAsB;IAC1B;IACA;QACI,aAAa;IACjB;;IAEA;QACI,eAAe;IACnB;IACA;QACI,eAAe;IACnB;IACA;QACI,WAAW;IACf;IACA;QACI,YAAY;QACZ,YAAY;QACZ,eAAe;IACnB;IACA;QACI,YAAY;IAChB;AACJ","sourcesContent":[".hero{\n    height: 100vh;\n    background: linear-gradient(180deg, #fde1ff, #e1ffea22 60%);\n    display: flex;\n}\n.hero-left{\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    gap: 20px;\n    padding-left: 180px;\n    line-height: 1.1;\n}\n.hero-left h2{\n    color: #090909;\n    font-size: 26px;\n    font-weight: 600;\n\n}\n.hero-left p{\n    color: #171717;\n    font-size: 100px;\n    font-weight: 700;\n\n}\n.hero-hand-icon{\n    display: flex;\n    align-items: center;\n    gap: 20px;\n\n}\n.hero-hand-icon img{\n    width: 105px;\n\n}\n.hero-latest-btn{\n    display: flex;\n    justify-content: center;\n    align-items: center;\n    gap: 15px;\n    width: 310px;\n    height: 70px;\n    border-radius: 75px;\n    margin-top: 30px;\n    background: #ff4141;\n    color: white;\n    font-size: 22px;\n    font-weight: 500;\n\n}\n.hero-right{\n    flex: 1;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n}\n\n@media(max-width:1280px){\n    .hero-left{\n        padding-left: 100px; \n    }\n    .hero-left h2{\n        font-size: 22px;\n    }\n    .hero-left p{\n        font-size: 60px;\n    }\n    .hero-hand-icon img{\n        width: 80px;\n    }\n    .hero-latest-btn{\n        gap: 10px;\n        width: 250px;\n        height: 60px;\n        margin-top: 20px;\n        font-size: 18px;\n    }\n    .hero-right img{\n        width: 500px;\n    }\n}\n@media(max-width:1024px){\n    .hero-left{\n        padding-left: 80px; \n    }\n    .hero-left h2{\n        font-size: 20px;\n    }\n    .hero-left p{\n        font-size: 50px;\n    }\n    .hero-hand-icon img{\n        width: 65px;\n    }\n    .hero-latest-btn{\n        width: 220px;\n        height: 50px;\n        font-size: 16px;\n    }\n    .hero-right img{\n        width: 400px;\n    }\n}\n@media(max-width:800px){\n    .hero-left{\n        padding-left: 30px; \n    }\n    .hero-left h2{\n        font-size: 16px;\n    }\n    .hero-left p{\n        font-size: 40px;\n    }\n    .hero-hand-icon img{\n        width: 50px;\n    }\n    .hero-latest-btn{\n        width: 175px;\n        height: 40px;\n        font-size: 13px;\n    }\n    .hero-right img{\n        width: 300px;\n    }\n}\n@media(max-width:500px){\n    .hero{\n        flex-direction: column;\n    }\n    .hero-right{\n        display: none;\n    }\n    \n    .hero-left h2{\n        font-size: 18px;\n    }\n    .hero-left p{\n        font-size: 50px;\n    }\n    .hero-hand-icon img{\n        width: 55px;\n    }\n    .hero-latest-btn{\n        width: 200px;\n        height: 45px;\n        font-size: 14px;\n    }\n    .hero-right img{\n        width: 300px;\n    }\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
